export default __webpack_public_path__ + "static/media/icon_arrow_down_small.7b1b0aa9.svg";